import { useState } from 'react';
import { authApiService } from '../services/auth';
import { storageService } from '../services/storage';
import { useApp } from '../context/AppContext';
import { useSelectedRestaurant } from '../context/SelectedRestaurantContext';
import { useNavigate } from 'react-router-dom';

/**
 * Hook personalizado para manejar el logout
 */
export const useLogout = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { clearCart, clearAllAppData } = useApp();
  const { clearSelectedRestaurant } = useSelectedRestaurant();
  const navigate = useNavigate();

  const logout = async (showConfirmation = true) => {
    console.log('🔄 useLogout - Función logout llamada, showConfirmation:', showConfirmation);
    
    if (isLoading) {
      console.log('⏳ useLogout - Ya hay un logout en progreso');
      return;
    }

    const performLogout = async () => {
      setIsLoading(true);
      try {
        console.log('🔄 Iniciando proceso de logout...');
        
        // 1. Cerrar sesión de Firebase
        await authApiService.signOut();
        console.log('✅ Sesión de Firebase cerrada');
        
        // 2. Limpiar carrito
        clearCart();
        console.log('✅ Carrito limpiado');
        
        // 3. Limpiar todos los datos de la aplicación (contexto)
        clearAllAppData();
        console.log('✅ Datos de aplicación limpiados');
        
        // 4. Limpiar restaurante seleccionado (contexto)
        clearSelectedRestaurant();
        console.log('✅ Restaurante seleccionado limpiado');
        
        // 5. Limpiar TODOS los datos de la aplicación (incluyendo localStorage)
        console.log('🔥 Limpiando TODOS los datos de la aplicación...');
        await storageService.clearAllAppData();
        console.log('✅ Todos los datos limpiados');
        
        // 6. Navegar a la pantalla principal
        navigate('/');
        console.log('✅ Navegación a pantalla principal');
        
        console.log('🎉 Logout completado exitosamente');
        
      } catch (error: any) {
        console.error('❌ Error durante logout:', error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    };

    if (showConfirmation) {
      const confirmed = window.confirm(
        '¿Estás seguro de que quieres cerrar sesión? Se limpiarán todos los datos locales.'
      );
      if (confirmed) {
        await performLogout();
      }
    } else {
      await performLogout();
    }
  };

  const logoutWithoutConfirmation = () => logout(false);

  return {
    logout,
    logoutWithoutConfirmation,
    isLoading
  };
}; 